import { Component } from '@angular/core';
import { SuperClass } from '../../../../superclass/SuperClass';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { BreadcrumbService } from '../../../../breadcrumb.service';
import { DashboardDataService } from '../../../../services/dashboard-data.service';
import { ClientsService } from '../../../../services/clients/clients.service';
import { WsService } from '../../../../services/websocket/WsService';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { RouterConst } from '../../../../globals/RoutersConst';
import { Globals } from '../../../../globals/Globals';
import { WiredMessengerAccount } from './wired-messenger-account.model';

@Component({
  selector: 'app-wired-manager-accounts',
  templateUrl: './wired-messenger-accounts.component.html',
  styleUrls: ['./wired-messenger-accounts.component.css'],
})
export class AnalyticsWiredMessengerAccountsComponent extends SuperClass {
  accounts: WiredMessengerAccount[];
  selectedRow: WiredMessengerAccount;
  newAccount: WiredMessengerAccount;
  newAccountForm: FormGroup;
  selectedRowForm: FormGroup;

  display = false;

  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
    private fb: FormBuilder,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );

    this.reloadData();

    this.breadcrumbService.setItems([
      { label: 'Organization' },
      { label: 'Accounts' },
      {
        label: 'Wired Messenger Accounts',
        routerLink: [
          { outlets: { sub: [RouterConst.ANALYTICS_WIRED_MESSENGER_ACC] } },
        ],
      },
    ]);
    this.newAccount = new WiredMessengerAccount();
  }

  reloadData() {
    this.http_getAllAccounts('wiredmessenger', (data: any) => {
      if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
        this.accounts = data.payload;
        console.log('this.accounts', this.accounts);
      }
    });

    this.selectedRowForm = this.fb.group({
      name: new FormControl('', Validators.required),
      guid: new FormControl('', Validators.required),
      // secret: new FormControl('', Validators.required),
    });

    this.newAccountForm = this.fb.group({
      name: new FormControl('', Validators.required),
      guid: new FormControl('', Validators.required),
      // secret: new FormControl('', Validators.required),
    });
  }

  selectRow(e) {
    this.selectedRow = new WiredMessengerAccount(e.data);
  }

  saveAccount() {
    // const requiredFields = [
    //   {id: 'name', value: this.selectedRow.name, fieldName: 'Name'},
    //   {id: 'appId', value: this.selectedRow.appId, fieldName: 'App Id'}
    // ];
    // if (this.hasEmptyFields(requiredFields)) {
    //   return;
    // }

    this.http_updateAccounts(
      this.selectedRow,
      'wiredmessenger',
      (data: any) => {
        this.showSuccessMessage('Account has been updated');
        this.unselectRow();
        this.accounts = data.payload;
      },
    );
  }

  addNewAccount() {
    this.display = true;
    this.newAccount = new WiredMessengerAccount();
  }

  createNewAccount() {
    // const requiredFields = [
    //   {id: 'new_name', value: this.newAccount.name, fieldName: 'Name'},
    //   {id: 'new_appId', value: this.newAccount.appId, fieldName: 'App Id'},
    //   {id: 'new_secret', value: this.newAccount.secret, fieldName: 'Secret'}
    // ];
    //
    // if (this.hasEmptyFields(requiredFields)) {
    //   return;
    // }

    this.http_addAccount(this.newAccount, 'wiredmessenger', (data: any) => {
      this.showSuccessMessage('Account has been created');
      this.unselectRow();
      this.accounts = data.payload;
    });
    this.display = false;
  }

  deleteAccount() {
    this.http_deleteAccount(this.selectedRow, 'wiredmessenger', (data: any) => {
      this.showSuccessMessage('Account has been deleted');
      this.unselectRow();
      this.accounts = data.payload;
    });
  }

  unselectRow() {
    this.selectedRow = undefined;
  }

  getWebSocketIdentifier(): string {
    return undefined;
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/accounts/wired-messenger-accounts/wired-messenger-accounts.component.ts